import type {ReactElement} from 'react';
import React from 'react';
import {BaseOutlineColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-outline-color-panel';
import type {RGBA} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';

export function TextOutlineColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemStrokeColor = useGetKeyFromTextStylesActiveItem('strokeColor');

  if (!activeItem || (activeItem && !('textStyles' in activeItem)) || !itemStrokeColor) {
    throw new Error(`Item doesn't have text styles property`);
  }

  const updateStrokeColor = (strokeColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        textStyles: {
          strokeColor,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseOutlineColorPanel strokeColor={itemStrokeColor} onUpdateStrokeColor={updateStrokeColor} />;
}
